import IconButton from "@material-ui/core/IconButton"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import { useSnackbar } from "notistack"
import React, { Component, useContext, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import Package from "../../../package.json"
import DesenvolvidoPor from "../../assets/desenvolvidoPor.png"
import { CalculosContext } from "../../contexts/CalculosContext"
import SiteContext from "../../contexts/SiteContext"
import {
    AtualizarStatusPedido,
    BuscarPedidosCliente,
    BuscarUltimoPedidoCliente,
    CadastrarEnderecoCliente,
    CadastrarPedido,
    CadastrarUsuario,
    EstabelecimentoAberto,
    eventoCheckout,
    eventoPurchase,
    formatarCpf,
    formatarParaDinheiro,
    formatReal,
    getMoney,
    identificarEstabelecimentoSelecionado,
    isNumeric,
    LoginGeral,
    novoCarrinho,
    ObterCardapio,
    ObterCardapioCompletoV1,
    ObterCupomDescontoCompleto,
    ObterEnderecosComTaxaEntrega,
    Post_ListarEstabelecimentosPorEndereco,
    RegistrarLogErro,
} from "../../services/functions"

import Avatar from "@material-ui/core/Avatar"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Slide from "@material-ui/core/Slide"
import { fade, makeStyles, useTheme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk"
import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import AlertFixo from "@material-ui/lab/Alert"
import Skeleton from "@material-ui/lab/Skeleton"
import PropTypes from "prop-types"
import { Col, Row } from "react-bootstrap"
import QrReader from "react-qr-reader"

import { LoginDialogContext } from "../../components/LoginDialog"
import useParametros from "../../contexts/ParametrosContext"
import Carrinho from "./carrinho"
import BuscaProdutos from "./components/BuscaProdutos"
import CabecalhoCategorias from "./components/CabecalhoCategorias"
import CategoriaGrid from "./components/CategoriaGrid"
import InfoCardapio from "./components/InfoCardapio"

function AvatarTipoEntrega(props) {
    return (
        <Avatar style={{ background: "#f9f9f9" }}>
            {props.retirada ? (
                <DirectionsWalkIcon style={{ color: props.color }} />
            ) : (
                <MotorcycleIcon style={{ color: props.color }} />
            )}
        </Avatar>
    )
}

function TabPanel(props) {
    const { children, ...other } = props

    return (
        <div role="tabpanel" {...other}>
            <Box p={3}>
                <div>{children}</div>
            </Box>
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
}

const useStyles = makeStyles(theme => ({
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        "&:hover": {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto",
        },
    },
    inputRoot: {
        color: "inherit",
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "20ch",
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    rootCardapio: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: "#f7f7f7",
    },
    cabecalho: { padding: "0 1rem" },
    root: {
        width: "100%",
        padding: "2em 0 2em 0",
    },
    heading: {
        textTransform: "uppercase",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    devHeading: {
        color: "#fff",
    },
    rootProduto: {
        maxWidth: 345,
    },
    media: {
        height: 140,
    },
    backdrop: {
        zIndex: "99999",
        color: "#fff",
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    rootAlerts: {
        margin: "0 0 1em 0",
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    fixedMesa: {
        position: "fixed",
        padding: "0!important",
        minHeight: "57px",
        zIndex: 1200,
        width: "100%!important",
        borderRadius: "0!important",
        left: 0,
        bottom: "0px",
        boxShadow: "none",
    },
    fixed: {
        position: "fixed",
        // bottom: theme.spacing(9),
        // right: theme.spacing(2),
        padding: "0!important",
        minHeight: "57px",
        zIndex: 1200,
        width: "100%!important",
        borderRadius: "0!important",
        left: 0,
        bottom: "56px",
        boxShadow: "none",
    },
    rootCarrinho: {
        width: "100%",
        //maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    // TODO: OUTROS LAYOUTS
    placeholder_Container: {
        margin: "-1.25rem 0.5rem 9.25rem 0.5rem",
    },
    placeholder_NomeCategoria: {
        maxWidth: "20rem",
    },
    placeholder_CardapioGrid: {
        marginTop: "-5.625rem",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        [theme.breakpoints.down("xs")]: {
            gridTemplateColumns: "1fr 1fr",
        },
        gridTemplateRows: "16.25rem 16.25rem 16.25rem",
        columnGap: "1.75rem",
    },
    placeholder_CardapioList: {
        marginTop: "-3.25rem",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "160px 160px 160px",
        columnGap: "1.75rem",
    },
    cardapioNotFound: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        minHeight: "10rem",
    },
    containerObservacao: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            "& > div": {
                width: "100%",
            },
        },
    },
    campoTextoObservacao: { margin: "1em 0", flex: 2 },
    buttonContainer: {
        justifyContent: "between",
        "& > button": {
            flex: 1,
            color: "white",
        },
        "& > button:nth-child(1)": {
            backgroundColor: "#dc3545",
        },
        "& > button:nth-child(2)": {
            backgroundColor: "#28a745",
        },
    },
}))

const CardapioPlaceHolder = ({ layout, categorias }) => {
    const classes = useStyles()

    if (categorias && categorias.length === 0)
        return (
            <div className={classes.placeholder_Container}>
                <span className={classes.cardapioNotFound}>
                    <Typography align="center" variant="h5" component="p">
                        O estabelecimento ainda não possui cardápio cadastrado
                    </Typography>
                </span>
            </div>
        )

    if (layout === "List")
        return (
            <div className={classes.placeholder_Container}>
                <Skeleton height={80} />
                <Skeleton height={50} />
                <Skeleton height={35} className={classes.placeholder_NomeCategoria} />
                <div className={classes.placeholder_CardapioList}>
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                    <Skeleton height={250} />
                </div>
            </div>
        )

    return (
        <div className={classes.placeholder_Container}>
            <Skeleton height={80} />
            <Skeleton height={50} />
            <Skeleton height={35} className={classes.placeholder_NomeCategoria} />
            <div className={classes.placeholder_CardapioGrid}>
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
            </div>
        </div>
    )
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const android = navigator.userAgent.includes("Android")
const iphone = navigator.userAgent.includes("iPad") || navigator.userAgent.includes("iPhone") //|| navigator.userAgent.includes('Mac OS')

export default function Cardapio(props) {
    const { mostrarWhatsapp } = props

    const classes = useStyles()
    const theme = useTheme()
    const history = useHistory()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))
    const { abrirDialogLogin, setAbrirDialogLogin } = useContext(LoginDialogContext)

    //loading
    var { enderecoAtual, atualizarAltura } = useContext(SiteContext)

    //loading
    const {
        aplicativoDados,

        estabelecimentoAtual,
        setEstabelecimentoAtual,

        loading,
        setLoading,

        usuarioLogado,
        setUsuarioLogado,

        carrinho,
        setCarrinho,
        setCard,
        setEnderecoAtual,

        cardapio,
        setCardapio,

        // setContinuarSemCadastro,
    } = useContext(SiteContext)

    const { ObterCardapioCalculo, calcularValorTotal, usarCarrinho } = useContext(CalculosContext)

    const parametros = useParametros()

    const usuarioIzza = JSON.parse(localStorage.getItem("usuarioIzzaCF"))
    const [nomeMesa, setNomeMesa] = useState(usuarioLogado?.cliente?.nome.replace("Mesa ", ""))
    const [cpf, setCpf] = useState(formatarCpf(usuarioLogado?.cliente?.cpf ?? ""))
    const [outrosEstabelecimentosEntregam, setOutrosEstabelecimentosEntregam] = useState([])
    const [queroMeCadastrar, setQueroMeCadastrar] = useState(false)
    const [openTelaLogin, setOpenTelaLogin] = useState({ open: false, telefone: "", nome: "" })

    const valorTotalItens = () => {
        let total = 0
        if (carrinho?.pedido?.itens?.length > 0) {
            carrinho.pedido.itens.forEach(item => {
                total += item.valorProdutoHistorico
            })
        }
        return total
    }

    const tempCart = carrinho

    if (!tempCart?.data || new Date() - new Date(tempCart?.data) > 3600000) {
        try {
            tempCart.pedido.itens = []
            tempCart.data = new Date()
            setCarrinho(tempCart)
        } catch (error) {
            //RegistrarLogErro(error, "?.")
        }
    }

    const [carrinhoOpen, setCarrinhoOpen] = useState(false)
    const [pagamentoOpen, setPagamentoOpen] = useState(false)
    const [informacoesPedido, setInformacoesPedido] = React.useState(false)
    const [InformacoesDoTipoEntrega, setInformacoesDoTipoEntrega] = React.useState(false)
    const [TelaRetiradaOuEntrega, setTelaRetiradaOuEntrega] = React.useState(false)
    const [MostrarFotoProduto, setMostrarFotoProduto] = React.useState({})
    const [AbrirMostrarFotoProduto, setAbrirMostrarFotoProduto] = React.useState(false)
    const [AdicionarCupom, setAdicionarCupom] = React.useState(false)
    const [ultimoPedido, setUltimoPedido] = React.useState({})
    const [layoutCardapio, setLayoutCardapio] = useState(
        estabelecimentoAtual.adicionarItensNaTelaInicial
            ? "AdicionarInicial"
            : aplicativoDados?.cardapioEmGrid
            ? "Grid"
            : "List"
    ) //true = list || false = grid ||
    const [removeItem, setRemoveItem] = useState(false)
    const [removeItemSelecionado, setRemoveItemSelecionado] = useState(0)
    // const [valueCategoria, setValueCategoria] = React.useState(0);
    const [RodarFuncaoAposIsso, setRodarFuncaoAposIsso] = React.useState("")
    const [qrCodeModal, setQrCodeModal] = React.useState(false)

    const DialogConfirmacaoinformacoes = open => {
        if (open) {
            eventoCheckout()
        }
        setInformacoesPedido(open)
    }

    const getValorTaxaEntrega = () => {
        if (carrinho?.pedido?.taxaEntrega) {
            return carrinho?.pedido?.taxaEntrega
        }

        if (enderecoAtual?.taxaEntrega >= 0) {
            //diferente de  -1 (-1 = não entrega)
            return enderecoAtual?.taxaEntrega
        }

        if (estabelecimentoAtual?.taxaEntrega) {
            return estabelecimentoAtual?.taxaEntrega
        }

        return -1
    }

    const parametroNumeroMesas = parametros.PUBLIC_NUMERO_MESAS
        ? Number(parametros.PUBLIC_NUMERO_MESAS)
        : null

    const [numeroMesas] = useState(Array.from(Array(parametroNumeroMesas ?? 50), (_, x) => x + 1))

    const usuarioPedidoMesa = JSON.parse(localStorage.getItem("usuarioPedidoMesaCF"))
    const temEndereco = !!enderecoAtual?.bairro

    const [isEntregaNoEndereco, setIsEntregaNoEndereco] = useState(
        temEndereco &&
            ((enderecoAtual?.taxaEntrega >= 0 && enderecoAtual?.taxaEntrega !== null) ||
                (carrinho?.pedido?.taxaEntrega >= 0 && carrinho?.pedido?.taxaEntrega !== null) ||
                (estabelecimentoAtual?.taxaEntrega >= 0 &&
                    estabelecimentoAtual?.taxaEntrega !== null))
    )

    useEffect(() => {
        if (enderecoAtual?.taxaEntrega >= 0) {
            setIsEntregaNoEndereco(true)
        } else setIsEntregaNoEndereco(false)
    }, [enderecoAtual])

    const valorTaxaEntrega = getValorTaxaEntrega()
    const isRetiradaNoLocal = enderecoAtual?.id === "retirada" || enderecoAtual?.id === -1
    const isUsuarioPedidoMesa = usuarioPedidoMesa?.logado
    const isUsuarioIzzaBot = usuarioIzza?.logado
    const itensValor = carrinho?.pedido?.itens?.length > 0 ? valorTotalItens() : 0
    const isFreteGratisMinimoEntrega =
        carrinho?.pedido?.itens?.length > 0 &&
        carrinho?.minimoEntregaGratis < 999 &&
        carrinho?.minimoEntregaGratis > 0 &&
        itensValor - carrinho.valorDesconto - carrinho.percentualDescontoValor >=
            carrinho?.minimoEntregaGratis
    const solicitarNomeAoFinalizar = !(
        isUsuarioPedidoMesa && aplicativoDados.solicitarNomePedidoMesa === false
    )
    const solicitarTelefoneAoFinalizar = !(
        isUsuarioPedidoMesa && aplicativoDados.solicitarTelefonePedidoMesa === false
    )
    const descontoCardapio = carrinho.percentualDescontoValor
        ? carrinho.percentualDescontoValor
        : cardapio?.valorDesconto
        ? cardapio.valorDesconto
        : carrinho?.valorDesconto
        ? carrinho.valorDesconto
        : 0
    const continuarSemCadastro =
        !usuarioLogado?.logado &&
        !usuarioPedidoMesa?.logado &&
        aplicativoDados?.permitirContinuarSemCadastro

    const calcularValorProdutos = () => {
        let valor = 0.0
        if (carrinho?.pedido && carrinho?.pedido?.itens) {
            if (carrinho.pedido.itens.length === 0) {
            } else if (carrinho.pedido.itens.length === 1) {
                valor = carrinho.pedido.itens[0].valorProdutoHistorico
                    ? carrinho.pedido.itens[0].valorProdutoHistorico
                    : 0.0
            } else {
                carrinho.pedido.itens.forEach(x => {
                    console.log("x", x)
                    let v = x.valorProdutoHistorico ? x.valorProdutoHistorico : 0.0
                    valor += v
                })
            }
        }
        return valor
    }

    const valorProdutos = calcularValorProdutos()
    const valorTotalMinimoEntregaCupom =
        valorProdutos + (valorTaxaEntrega < 0 || !valorTaxaEntrega ? 0 : valorTaxaEntrega)
    const valorTotalMinimoEntregaPedido = carrinho?.pedido?.valorTotal
        ? carrinho?.pedido?.valorTotal
        : 0

    console.log("valorTotalMinimoEntregaCupom", valorTotalMinimoEntregaCupom)

    const isRetiradaValorMinimo = cardapio?.valorMinimoRetiradaNoLocal > 0 && isRetiradaNoLocal

    var prevScrollpos = window.pageYOffset

    const alterarQuantidadeNoCardapio = (produtoSelecionado, quantidade) => {
        if (!cardapio?.categorias?.length) return {}

        for (const categoria of cardapio.categorias) {
            if (!categoria.produtos?.length) continue
            for (const produto of categoria.produtos) {
                if (produto.id === produtoSelecionado.id) {
                    produto.quantidade = quantidade
                    return cardapio
                }
            }
        }
        return cardapio
    }

    const selecionarProduto = produto => {
        if (!produto.produtoExibicao) {
            if (isEntregaNoEndereco === false && temEndereco) {
                if (estabelecimentoAtual.permiteRetiradaBalcao) {
                    setRodarFuncaoAposIsso(`produto${produto.id}`)
                    setTelaRetiradaOuEntrega(true)
                } else {
                    irParaEnderecos()
                }
            } else {
                irParaProduto(produto.id)
            }
        }
    }

    const removerProdutoCarrinho = produto => {
        //funcao para remover quantidade ou produto na tela de cardapio

        var temNoCarrinho = false
        var novoCardapio = cardapio

        //verificar se exite o produto no carrinho
        //altera a quantidade ou remove do carrinho
        carrinho.pedido.itens.forEach((item, index) => {
            if (temNoCarrinho == false && item.produto.id == produto.id) {
                const valorProduto = item.valorProdutoHistorico / item.quantidade

                const qtdRemover = item.produto.qntMultiplicativaProdutos
                    ? item.produto.qntMultiplicativaProdutos
                    : 1
                item.quantidade -= qtdRemover

                // //console.log('item ', item)
                // //console.log('pedido', produto)
                // //console.log('quantidade minima', item.produto.qntMinimaProdutos)
                // //console.log('quantidade ', item.quantidade)
                if (item.quantidade == 0 || item.quantidade < item.produto.qntMinimaProdutos) {
                    item.quantidade = 0 // para item.quantidade < item.qntMinimaProdutos
                    carrinho.pedido.itens.splice(index, 1) //remvoer do carrinho
                } else {
                    item.valorProdutoHistorico -= valorProduto * qtdRemover
                    temNoCarrinho = true
                }
                //atualiza na tela
                novoCardapio = alterarQuantidadeNoCardapio(produto, item.quantidade)
            }
        })

        //atualiza os JSON's
        carrinho.data = new Date()

        //calcula valor total

        calcularValorTotal({
            carrinho: carrinho,
            cardapio: novoCardapio,
            enderecoAtual,
        })
    }

    const numberoProdutoCarrinho = (produto, numero = 0) => {
        if (isNaN(numero)) {
            numero = 0
        }
        console.log("numberoProdutoCarrinho", numero)
        //funcao para adicionar produto na tela de cardapio

        if (
            produto.quantidade &&
            produto.qntMaximaProdutos &&
            numero >= produto.qntMaximaProdutos
        ) {
            alertStart(`Máximo ${produto.qntMaximaProdutos} já selecionado!`, "warning")
            return false
        }

        var temNoCarrinho = false
        var novoCardapio = cardapio

        //verificar se exite o produto no carrinho
        //altera a quantidade ou adiciona no carrinho
        carrinho.pedido.itens.forEach((item, index) => {
            //item == produto
            if (temNoCarrinho == false && item.produto.id == produto.id) {
                const valorProduto = item.valorProdutoHistorico / item.quantidade
                const qtdAdicionar = numero
                item.quantidade = qtdAdicionar
                item.valorProdutoHistorico = valorProduto * qtdAdicionar
                if (numero === 0) {
                    carrinho.pedido.itens.splice(index, 1)
                }
                temNoCarrinho = true
                novoCardapio = alterarQuantidadeNoCardapio(produto, item.quantidade)
            }
        })

        // se nao tiver no carrinho ele adiciona no carrinho
        if (temNoCarrinho == false) {
            //console.log('adicionarProdutoCarrinho', produto)

            //limpando variaveis que o sistema adm nao aceita
            var produtoLimpo = JSON.parse(JSON.stringify(produto))
            delete produtoLimpo.valorDeCalculado
            delete produtoLimpo.valorRealCalculado
            delete produtoLimpo.quantidade
            const qtdAdd = numero
            const produtoProCarrinho = {
                id: null,
                produto: produtoLimpo,
                quantidade: qtdAdd,
                valorProdutoHistorico: produto.valor * qtdAdd,
                itensOpcaoProduto: [],
                observacao: "",
                token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
            }
            produtoProCarrinho.valorProdutoHistorico *= produtoProCarrinho.quantidade
            if (numero !== 0) {
                carrinho.pedido.itens.push(produtoProCarrinho)
            }

            //altera na tela
            novoCardapio = alterarQuantidadeNoCardapio(produto, produtoProCarrinho.quantidade)
        }

        //atualiza os JSON's

        carrinho.data = new Date()

        //calcula valor total
        calcularValorTotal({
            carrinho: carrinho,
            cardapio: novoCardapio,
            enderecoAtual,
        })

        window.dispatchEvent(
            new CustomEvent("adicionouCarrinho", {
                detail: {
                    value: produto.valor,
                    items: [
                        {
                            item_id: produto.id,
                            item_name: produto.nome,
                            price: produto.valor,
                            quantity: numero,
                        },
                    ],
                },
            })
        )
    }

    const adicionarProdutoCarrinho = produto => {
        //funcao para adicionar produto na tela de cardapio

        if (produto.quantidade && produto.quantidade == produto.qntMaximaProdutos) {
            alertStart(`Máximo ${produto.qntMaximaProdutos} já selecionado!`, "warning")
            return false
        }

        var temNoCarrinho = false
        var novoCardapio = cardapio

        //verificar se exite o produto no carrinho
        //altera a quantidade ou adiciona no carrinho
        carrinho.pedido.itens.forEach(item => {
            //item == produto
            if (temNoCarrinho == false && item.produto.id == produto.id) {
                const valorProduto = item.valorProdutoHistorico / item.quantidade
                const qtdAdicionar = item.produto.qntMultiplicativaProdutos
                    ? item.produto.qntMultiplicativaProdutos
                    : 1
                item.quantidade += qtdAdicionar
                item.valorProdutoHistorico += valorProduto * qtdAdicionar
                temNoCarrinho = true

                //altera na tela
                novoCardapio = alterarQuantidadeNoCardapio(produto, item.quantidade)
            }
        })

        // se nao tiver no carrinho ele adiciona no carrinho
        if (temNoCarrinho == false) {
            //console.log('adicionarProdutoCarrinho', produto)

            //limpando variaveis que o sistema adm nao aceita
            var produtoLimpo = JSON.parse(JSON.stringify(produto))
            delete produtoLimpo.valorDeCalculado
            delete produtoLimpo.valorRealCalculado
            delete produtoLimpo.quantidade
            const qtdAdd = produto.qntMinimaProdutos
                ? produto.qntMinimaProdutos
                : produto.qntMultiplicativaProdutos
                ? produto.qntMultiplicativaProdutos
                : 1
            const produtoProCarrinho = {
                id: null,
                produto: produtoLimpo,
                quantidade: qtdAdd,
                valorProdutoHistorico: produto.valor * qtdAdd,
                itensOpcaoProduto: [],
                observacao: "",
                token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
            }
            produtoProCarrinho.valorProdutoHistorico *= produtoProCarrinho.quantidade
            carrinho.pedido.itens.push(produtoProCarrinho)

            //altera na tela
            novoCardapio = alterarQuantidadeNoCardapio(produto, produtoProCarrinho.quantidade)
        }

        //atualiza os JSON's

        carrinho.data = new Date()

        //calcula valor total
        calcularValorTotal({
            carrinho: carrinho,
            cardapio: novoCardapio,
            enderecoAtual,
        })

        window.dispatchEvent(
            new CustomEvent("adicionouCarrinho", {
                detail: {
                    value: produto.valor,
                    items: [
                        {
                            item_id: produto.id,
                            item_name: produto.nome,
                            price: produto.valor,
                            quantity: produto.quantidade,
                        },
                    ],
                },
            })
        )
    }

    const [openInformacoes, setOpenInformacoes] = React.useState(false)

    const buscarUltimoPedido = async () => {
        try {
            if (usuarioLogado?.logado) {
                const data = usuarioLogado.cliente
                data.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`

                const retorno = await BuscarUltimoPedidoCliente(data, aplicativoDados)

                if (retorno.retornoErro) {
                    // verificar se o erro é pq não tem ultimo pedido
                    // alertStart(retornoCep.mensagem, "error")
                } else {
                    if (retorno == "") {
                        localStorage.setItem("semUltimoPedido", "true")
                    } else {
                        localStorage.removeItem("semUltimoPedido")
                    }

                    setUltimoPedido(retorno)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "BuscarUltimoPedidoCliente")
            alertStart(
                "Procure os desenvolvedores! Erro BuscarUltimoPedidoCliente: " + error.message,
                "error"
            )
        }
    }

    //alerts
    const { enqueueSnackbar } = useSnackbar()

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    ////console.log("carrinho", carrinho)
    ////console.log("usuarioLogado", usuarioLogado)
    console.log("estabelecimentoAtual", estabelecimentoAtual)

    const verificarAberto = async () => {
        ////console.log("atualizando aberto-fechado")
        try {
            const resposta = await EstabelecimentoAberto(estabelecimentoAtual.id, aplicativoDados)
            //testar bem
            if (!estabelecimentoAtual.id) {
                return
            }

            if (resposta.retornoErro) {
                //algum erro verificarAberto
            } else {
                if (
                    estabelecimentoAtual.online !== resposta.online ||
                    estabelecimentoAtual.pausado !== resposta.pausado
                ) {
                    if (resposta.online) {
                        if (resposta.pausado) {
                            alertStart(
                                "O estabelecimento está aberto, porém pausado no momento!",
                                "info"
                            )
                        } else {
                            alertStart("O estabelecimento está aberto!", "info")
                        }
                    } else {
                        alertStart("O estabelecimento está fechado!", "info")
                    }
                    estabelecimentoAtual.online = resposta.online
                    estabelecimentoAtual.pausado = resposta.pausado
                    setEstabelecimentoAtual(estabelecimentoAtual)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "EstabelecimentoAberto", aplicativoDados)
            alertStart(
                "Procure os desenvolvedores! Erro EstabelecimentoAberto: " + error.message,
                "error"
            )
        }
    }

    const quantidadeProdutos = () => {
        var qtd = 0
        carrinho.pedido.itens.forEach(item => {
            qtd += item.quantidade
        })
        return qtd
    } //carrinho.pedido?.itens.length
    const lerQrCodeComanda = () => {
        setQrCodeModal(true)
    }

    const enviarPedidoWhatsapp = async ({ carrinho = usarCarrinho() }) => {
        try {
            window.dispatchEvent(new CustomEvent("enviarPedidoWhatsapp"))

            setLoading(true)
            let data = new Date()

            let dataPedido = `*Data*: ${data.toLocaleDateString()} - ${data.toLocaleTimeString()}%0A`
            let nome = `*Nome*: ${carrinho.pedido.nomePedido}%0A`
            let telefone = `*Telefone*: ${carrinho.pedido.telefoneCliente}%0A`
            let formaPagamento = `*Forma de Pagamento*: ${carrinho.formaPagamentoDescricao}%0A`
            let trocoDinheiro = ""
            let observacaoPedido = ""
            if (carrinho.pedido.observacao) {
                observacaoPedido = `*Observação*: ${carrinho.pedido.observacao}%0A`
            }
            if (carrinho.pedido.formaPagamento.id == 1 && carrinho.pedido.troco != 0) {
                trocoDinheiro = `%0A*Troco Para*: ${formatarParaDinheiro(carrinho.pedido.troco)}`
            }
            let valorTotal = `%0A*VALOR TOTAL PEDIDO*: ${formatarParaDinheiro(
                carrinho.pedido.valorTotal
            )}%0A`

            let traco = `_____________%0A`
            var produto = ""
            for (var i = 0; i < carrinho.pedido.itens.length; i++) {
                //console.log('carrinho.pedido.itens.length', carrinho.pedido.itens.length)
                let produtoAtual = carrinho.pedido.itens[i]
                //`Monte seu açaí\n1 X Açaí 500 ML\n> 1 X Sem calda\n> 1 X Banana\nValor: R$ 13.00\n`
                var textoProdutoAtual = `*${produtoAtual.quantidade} X* ${produtoAtual.produto.nome}%0A`

                for (var j = 0; j < produtoAtual.itensOpcaoProduto.length; j++) {
                    //console.log('produtoAtual.itensOpcaoProduto.length', produtoAtual.itensOpcaoProduto.length)
                    var opcaoAtual = produtoAtual.itensOpcaoProduto[j]
                    textoProdutoAtual += ` >>> *${opcaoAtual.quantidade} X* ${opcaoAtual.opcaoProduto.nome}%0A`
                }

                if (produtoAtual.observacao) {
                    textoProdutoAtual += `*Observação*: ${produtoAtual.observacao}%0A`
                }
                textoProdutoAtual += `*Valor*: ${formatarParaDinheiro(
                    produtoAtual.valorProdutoHistorico
                )}%0A`

                if (carrinho.pedido.itens.length > 1 && i < carrinho.pedido.itens.length - 1) {
                    textoProdutoAtual += `%0A`
                }

                produto += textoProdutoAtual
            }

            let final = "%0A_Plataforma ClienteFielStart_"

            var comanda =
                dataPedido +
                nome +
                telefone +
                observacaoPedido +
                formaPagamento +
                traco +
                produto +
                traco +
                trocoDinheiro +
                valorTotal +
                traco +
                final
            // comanda = comanda.replace(/ /g, '%20');
            await resetarCarrinho()
            //console.log(comanda)
            //console.log(`https://api.whatsapp.com/send?phone=55${estabelecimentoAtual.numeroWhatsapp}&text=${comanda}`)
            window.location.href = `https://api.whatsapp.com/send?phone=55${estabelecimentoAtual.numeroWhatsapp}&text=${comanda}`
            setLoading(false)
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "enviarPedidoWhatsapp", carrinho)
        }
    }

    const realizarLogin_DosSemContinuarSemCadastro = async ({
        nome,
        telefoneReplace,
        carrinho = usarCarrinho(),
    }) => {
        try {
            if (telefoneReplace.charAt(0) == "0") {
                telefoneReplace = telefoneReplace.substring(1)
            }

            const ddiInput = document.getElementById("ddi-select")
            const minLength = ddiInput.dataset.minLength
            const maxLength = ddiInput.dataset.maxLength

            if (telefoneReplace.length < minLength || telefoneReplace.length > maxLength) {
                alertStart("Seu telefone está incompleto", "warning")
                return false
            }

            setLoading(true)

            //ENVIAR CADASTRO

            const data = {
                appNome: aplicativoDados.appNome,
                nome: "Cliente",
                telefone: "00000000000",
                dataNascimentoTexto: "",
                tipoUsuario: 1,
                email: `${aplicativoDados.appNome}@cliente_fiel.sem_cadastro.sistema`,
                hashSenha: `${aplicativoDados.appNome}@cliente_fiel.sem_cadastro.sistema`,
                cpf: cpf,
                token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
            }

            const response = await CadastrarUsuario(data, aplicativoDados)

            if (response.retornoErro && !response.mensagem?.includes("Já existe cliente")) {
                //algum erro
                alertStart(response.mensagem, "error")
                setLoading(false)
                return false
            } else {
                const data_Login = {
                    appNome: aplicativoDados.appNome,
                    cliente: {
                        email: `${aplicativoDados.appNome}@cliente_fiel.sem_cadastro.sistema`,
                        hashSenha: `${aplicativoDados.appNome}@cliente_fiel.sem_cadastro.sistema`,
                        appNome: aplicativoDados.appNome,
                        token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                    },
                    localizacao: {
                        latitude: "",
                        longitude: "",
                        token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                        appNome: aplicativoDados.appNome,
                    },
                    token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                }

                const response_LoginGeral = await LoginGeral(data_Login, aplicativoDados)

                if (response_LoginGeral.retornoErro) {
                    //algum erro LoginGeral
                    alertStart(response_LoginGeral.mensagem, "error")
                    setLoading(false)
                    return
                }

                setLoading(false)
                response_LoginGeral.cliente.cpf = cpf ? cpf : null

                enviarPedido({
                    usuarioEnviarPedido: response_LoginGeral,
                })
            }
        } catch (error) {
            RegistrarLogErro(error, "realizarLogin_DosSemContinuarSemCadastro")
            alertStart(
                "Procure os desenvolvedores! Erro realizarLogin_DosSemContinuarSemCadastro: " +
                    error.message,
                "error"
            )
        }
    }

    const confirmacaoInformacoes = ({
        perguntarSemCadastro = continuarSemCadastro,
        usuario = usuarioLogado,
        telaLogin = false,
    } = {}) => {
        try {
            var telefone = ""
            var nome = ""

            if (solicitarTelefoneAoFinalizar) {
                document.getElementById("telefonePedido").value = document
                    .getElementById("telefonePedido")
                    .value?.replace(" ", "")
                    .replace(".", "")
                    .replace("-", "")
                    .replace("(", "")
                    .replace(")", "")
                    .replace("/", "")
                telefone = document
                    .getElementById("telefonePedido")
                    ?.value?.replace(/([^\d])+/gim, "")

                const ddiInput = document.getElementById("ddi-select")
                const minLength = ddiInput.dataset.minLength
                const maxLength = ddiInput.dataset.maxLength

                if (!telefone || telefone.length > maxLength || telefone.length < minLength) {
                    alertStart("Digite um telefone válido", "warning")
                    return false
                }
            }

            if (solicitarNomeAoFinalizar) {
                nome = document.getElementById("nomePedido").value

                if (!nome) {
                    alertStart("Digite seu nome", "warning")
                    return false
                }

                carrinho.pedido.nomePedido = nome
            }

            if (continuarSemCadastro && !telaLogin && queroMeCadastrar) {
                setOpenTelaLogin({
                    open: true,
                    telefone: solicitarTelefoneAoFinalizar
                        ? document.getElementById("telefonePedido").value
                        : null,
                    nome: solicitarNomeAoFinalizar
                        ? document.getElementById("nomePedido").value
                        : null,
                })
                return false
            }

            const obs = document.getElementById("observacaoPedido")?.textContent ?? ""
            carrinho.pedido.observacao = obs

            if (aplicativoDados.clienteFielStart || (continuarSemCadastro === true && !telaLogin)) {
                carrinho.pedido.telefoneCliente = telefone
                setCarrinho(carrinho)

                if (aplicativoDados.clienteFielStart) {
                    enviarPedidoWhatsapp({
                        carrinho,
                    })
                } else {
                    realizarLogin_DosSemContinuarSemCadastro({
                        nome,
                        telefoneReplace: telefone,
                        carrinho,
                    })
                }
            } else {
                usuario.cliente.telefone = telefone
                usuario.cliente.codigoPais = document.getElementById("ddi-select")?.textContent

                if (isUsuarioPedidoMesa) {
                    if (
                        !aplicativoDados.permiteEscolherPagamentoMesa ||
                        !carrinho.pedido.formaPagamento
                    ) {
                        carrinho.pedido.formaPagamento = {
                            id: 41,
                        }
                    }

                    const mesa = document.getElementById("numeroDaMesa").innerText
                    if (mesa === "Não Selecionada" || mesa === "​") {
                        alertStart("Selecione a mesa para entregar", "warning")
                        return true
                    }
                    carrinho.pedido.mesa = mesa.replace("Mesa ", "")
                    carrinho.mesa = mesa.replace("Mesa ", "")
                    setNomeMesa(mesa)

                    //pedido de mesa e nao quer nome e telefone
                    if (solicitarNomeAoFinalizar) {
                        usuarioPedidoMesa.cliente.nome = nome
                    } else {
                        carrinho.pedido.nomePedido = mesa
                        usuarioPedidoMesa.cliente.nome = mesa
                    }

                    if (estabelecimentoAtual?.possuiPedidoMesa === false) {
                        RegistrarLogErro({}, "erroMesaEntrega - isUsuarioPedidoMesa", {
                            carrinho,
                            estabelecimentoAtual,
                            usuarioPedidoMesa,
                        })
                    }
                } else if (isUsuarioIzzaBot) {
                    carrinho.pedido.nomePedido = nome
                }
                localStorage.setItem("usuarioPedidoMesaCF", JSON.stringify(usuarioPedidoMesa))
                // alert(usuarioPedidoMesa?.cliente?.nome)

                setUsuarioLogado(usuario)
                setCarrinho(carrinho)

                if (isUsuarioPedidoMesa && estabelecimentoAtual.solicitarComanda) lerQrCodeComanda()
                else
                    enviarPedido({
                        usuarioEnviarPedido: usuario,
                        carrinhoEnviarPedido: carrinho,
                    })
            }
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "confirmacaoInformacoes", carrinho)
        }
    }

    const adicionarQuantidadeZeroProdutos = retornoCardapio => {
        if (carrinho.pedido?.itens?.length > 0) {
            retornoCardapio?.categorias?.forEach(categoria => {
                categoria.produtos.forEach(produto => {
                    var temNoCarrinho = false
                    carrinho.pedido.itens.forEach(item => {
                        if (item.produto.id == produto.id) {
                            produto.quantidade = item.quantidade
                            temNoCarrinho = true
                        }
                    })

                    if (temNoCarrinho == false) {
                        produto.quantidade = 0
                    }
                })
            })
        } else {
            retornoCardapio?.categorias?.forEach(categoria => {
                categoria.produtos.forEach(produto => {
                    produto.quantidade = 0
                })
            })
        }
        return retornoCardapio
    }

    const verificarCardapio = async estabelecimento => {
        console.log("verificarCardapio")
        await ObterCardapioCalculo({
            estabelecimentoAtual: estabelecimento,
        })

        adicionarCupom()
    }

    const listarEstabelecimentosPorEndereco = async data => {
        try {
            data.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`
            data.appNome = aplicativoDados.appNome

            const retorno = await Post_ListarEstabelecimentosPorEndereco(data, aplicativoDados)
            console.log("Post_ListarEstabelecimentosPorEndereco", retorno)
            if (retorno.retornoErro) {
                // alertStart(retorno.mensagem, "error")
            } else {
                setOutrosEstabelecimentosEntregam(retorno.filter(e => e.taxaEntrega != -1))
            }
        } catch (e) {}
    }

    useEffect(() => {
        if (!estabelecimentoAtual?.id) history.push("/")

        verificarCardapio()

        setTimeout(() => {
            setCard(cardapio => {
                if (!cardapio?.id) {
                    verificarCardapio()
                }

                return cardapio
            })
        }, 3000)
    }, [])

    useEffect(() => {
        if (cardapio?.id && !estabelecimentoAtual?.id) {
            if (cardapio?.idEstabelecimento) {
                const estabelecimento = aplicativoDados.estabelecimentos.filter(
                    es => es.id === cardapio?.idEstabelecimento
                )
                if (estabelecimento.length) {
                    setEstabelecimentoAtual(estabelecimento[0])
                }
            }
        }
    }, [estabelecimentoAtual, cardapio])

    useEffect(() => {
        console.log(aplicativoDados.estabelecimentos.length > 1, temEndereco)
        if (aplicativoDados.estabelecimentos.length > 1 && temEndereco) {
            listarEstabelecimentosPorEndereco(enderecoAtual)
        }

        if (!aplicativoDados.clienteFielStart) {
            verificarAberto()
            buscarUltimoPedido()
        }
        const interval = setInterval(() => {
            ////console.log("procurando atualizações ")
            if (!aplicativoDados.clienteFielStart) {
                verificarAberto()
                if (!localStorage.getItem("semUltimoPedido")) {
                    buscarUltimoPedido()
                }
            }
        }, 30000)
        return () => clearInterval(interval)
    }, [estabelecimentoAtual])

    useEffect(() => {
        atualizarAltura()
        return () => atualizarAltura(-200)
    }, [])

    class QRCode extends Component {
        state = {
            result: "No result",
            leu: false,
        }

        handleScan = data => {
            if (data && !this.state.leu) {
                setQrCodeModal(false)

                this.setState({
                    result: data,
                    leu: true,
                })

                carrinho.pedido.comanda = data
                window.dispatchEvent(new CustomEvent("qrCodeConfirmarComanda"))
                console.log("setCarrinho", "QRCode")

                enviarPedido({
                    carrinhoEnviarPedido: carrinho,
                })
            }
        }

        handleError = error => {
            setQrCodeModal(false)
            RegistrarLogErro(error, "RegistrarSelo")
            alertStart("Algo deu errado ao registrar selo  (handleError)", "error")
        }

        render() {
            if (qrCodeModal) {
                return (
                    <div>
                        <QrReader
                            delay={300}
                            onError={this.handleError}
                            onScan={this.handleScan}
                            style={{ width: "100%" }}
                        />
                    </div>
                )
            } else {
                return <div></div>
            }
        }
    }

    const removerCupom = async () => {
        try {
            const cardapio = await ObterCardapioCompletoV1(
                {
                    idCliente: usuarioLogado?.cliente?.id,
                    idEstabelecimento: estabelecimentoAtual?.id,
                    token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                },
                aplicativoDados
            )
            localStorage.removeItem("cupomLink")
            window.setCookie("cupom-digitado", "", 0)
            setLoading(true)

            if (cardapio.idCartelaCompleta) {
                window.dispatchEvent(new CustomEvent("removerFidelidade"))
            } else if (cardapio.cupomDesconto) {
                window.dispatchEvent(new CustomEvent("removerCupom"))
            }

            if (
                !isRetiradaNoLocal &&
                (carrinho.cupomDesconto?.freteGratis || cardapio.idCartelaCompleta)
            ) {
                const data = {
                    idCliente: usuarioLogado?.cliente?.id,
                    idEstabelecimento: estabelecimentoAtual?.id,
                    token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                }

                const retornoEnderecos = await ObterEnderecosComTaxaEntrega(data, aplicativoDados)
                retornoEnderecos.forEach(endereco => {
                    if (endereco.id === enderecoAtual.id) {
                        enderecoAtual = endereco
                    }
                })
                carrinho.pedido.valorEntrega = enderecoAtual.taxaEntrega
                carrinho.pedido.taxaEntrega = enderecoAtual.taxaEntrega
            }

            cardapio.idCartelaCompleta = null
            cardapio.percentualDesconto = 0
            cardapio.valorDesconto = 0
            carrinho.percentualDescontoValor = 0
            carrinho.percentualDesconto = 0
            carrinho.valorDesconto = 0
            carrinho.pedido.valorDesconto = 0

            carrinho.pedido.desconto = null

            cardapio.cupomDesconto = null
            carrinho.cupomDesconto = null
            cardapio.informacao = null

            calcularValorTotal({
                carrinho: carrinho,
                cardapio: cardapio,
                enderecoAtual: enderecoAtual,
            })
        } catch (error) {
            RegistrarLogErro(error, "removerCupom", carrinho)
            alertStart("Procure os desenvolvedores! Erro removerCupom: " + error.message, "error")
        }
        setLoading(false)
    }
    const jsonCupomRequest = codigo => {
        const data = JSON.parse(JSON.stringify(carrinho.pedido))
        data.estabelecimento = estabelecimentoAtual
        data.cliente = usuarioLogado.cliente
        data.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`
        data.desconto = {
            codigoCupom: codigo,
            appNome: aplicativoDados.appNome,
            mensagem: aplicativoDados.appNome,
            token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
        }
        return data
    }

    const adicionarCupomLink = async codigo => {
        const data = jsonCupomRequest(codigo)
        return await ObterCupomDescontoCompleto(data, aplicativoDados)
    }

    const adicionarCupom = async () => {
        const codigoCupomInput = document.getElementById("codigoAddCupom")
        const cupomCookie = window.getCookie("cupom-digitado")

        const codigoCupom = codigoCupomInput?.value ? codigoCupomInput.value : cupomCookie

        if (!codigoCupom) return

        const data = jsonCupomRequest(codigoCupom)

        try {
            setLoading(true)

            const response = await ObterCupomDescontoCompleto(data, aplicativoDados)

            if (response.retornoErro) {
                //algum erro ObterCupomDescontoCompleto
                setAdicionarCupom(false)
                alertStart(response.mensagem, "error")
            } else {
                window.dispatchEvent(new CustomEvent("adicionarCupom"))
                //tudo certo ObterCupomDescontoCompleto

                // if(response.freteGratis && carrinho.pedido?.entregaAgendada == "Retirar(Buscar) no local"){
                if (response.freteGratis && isRetiradaNoLocal) {
                    setAdicionarCupom(false)
                    alertStart(
                        "Esse cupom possui Frete Grátis e você está como Retirada no Local!",
                        "warning"
                    )
                    setLoading(false)
                } else {
                    // alertStart(response.mensagem , "success")
                    if (response.freteGratis) {
                        carrinho.pedido.valorEntrega = 0
                        carrinho.pedido.taxaEntrega = 0
                    }
                    cardapio.cupomDesconto = response
                    cardapio.percentualDesconto = response.valorDescontoPercentual
                    cardapio.valorDesconto = response.valorDesconto
                    carrinho.cupomDesconto = response
                    carrinho.percentualDescontoValor = response.valorDescontoPercentual
                    carrinho.valorDesconto = response.valorDesconto
                    calcularValorTotal({
                        carrinho: carrinho,
                        cardapio: cardapio,
                        enderecoAtual: enderecoAtual,
                    })
                    setAdicionarCupom(false)

                    window.setCookie("cupom-digitado", data.desconto.codigoCupom, 1 / 24)
                }
            }

            if (codigoCupomInput) codigoCupomInput.value = ""
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "adicionarCupom", data)
            alertStart("Procure os desenvolvedores! Erro adicionarCupom: " + error.message, "error")
            setLoading(false)
        }
    }

    const opcoesParaEntregaeRetirada = () => {
        if (estabelecimentoAtual.permiteRetiradaBalcao) {
            setTelaRetiradaOuEntrega(true)
        } else {
            irParaEnderecos()
        }
    }

    const irParaEstabelecimentos = () => {
        history.push(`/lojas`)
        setLoading(false)
    }

    const irParaEnderecos = () => {
        if (usuarioLogado?.logado) {
            history.push(
                `/delivery/enderecos${identificarEstabelecimentoSelecionado(aplicativoDados)}`
            )
            setLoading(false)
        } else {
            setTelaRetiradaOuEntrega(false)
        }
    }
    const irParaHistoricoDePedidos = () => {
        history.push(`/delivery/historicoPedidos`)
        setLoading(false)
    }
    const irParaLogin = () => {
        history.push(`/login`)
        setLoading(false)
    }

    const irParaProduto = produtoId => {
        history.push(
            `/produto/${produtoId}${identificarEstabelecimentoSelecionado(aplicativoDados)}`
        )
        setLoading(false)
    }
    const irParaStatusPedido = (pedidoId, pedidoStatusInicial, veioDoEnviarPedido) => {
        try {
            if (veioDoEnviarPedido == true) {
                history.push(
                    `/delivery/pedido${identificarEstabelecimentoSelecionado(
                        aplicativoDados,
                        pedidoId,
                        pedidoStatusInicial
                    )}?pedidoEnviado=true`
                )
            } else {
                history.push(
                    `/delivery/pedido${identificarEstabelecimentoSelecionado(
                        aplicativoDados,
                        pedidoId,
                        pedidoStatusInicial
                    )}`
                )
            }
            setLoading(false)
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "irParaStatusPedido", {
                pedidoId,
                pedidoStatusInicial,
                veioDoEnviarPedido,
            })
        }
    }

    const selecioneiEndereco = async () => {
        if (!usuarioLogado?.logado) {
            irParaEstabelecimentos()
        } else {
            irParaEnderecos()
        }
    }

    const selecioneiRetiradaNoLocal = async () => {
        await calcularValorTotal({
            carrinho,
            cardapio,
            enderecoAtual: { id: "retirada" },
        })

        setTelaRetiradaOuEntrega(false)
        setInformacoesDoTipoEntrega(false)

        if (RodarFuncaoAposIsso.includes("produto")) {
            irParaProduto(RodarFuncaoAposIsso.replace("produto", ""))
        }
    }

    const EnderecoPedidoMesa = async () => {
        await calcularValorTotal({
            carrinho,
            cardapio,
            enderecoAtual,
        })
    }

    async function resetarCarrinho() {
        try {
            const estabelecimento = estabelecimentoAtual
            estabelecimento.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`

            console.log("resetarCarrinho")
            const response = await ObterCardapio(estabelecimento, aplicativoDados)

            if (response.retornoErro) {
                //algum erro
                alertStart(response.mensagem, "error")
            } else {
                //tudo certo
                const retorno = response

                const carrinhoRetorno = {}
                carrinhoRetorno.valorMinimoPedido = retorno.valorMinimoPedido
                carrinhoRetorno.valorMinimoRetiradaNoLocal = retorno.valorMinimoRetiradaNoLocal
                carrinhoRetorno.valorDesconto = retorno.valorDesconto
                carrinhoRetorno.percentualDesconto = retorno.percentualDesconto
                carrinhoRetorno.minimoEntregaGratis = retorno.minimoEntregaGratis
                carrinhoRetorno.maximoPedidoComDesconto = retorno.maximoPedidoComDesconto
                carrinhoRetorno.maximoDesconto = retorno.maximoDesconto
                carrinhoRetorno.cupomDesconto = retorno.cupomDesconto

                carrinhoRetorno.pedido = {
                    entregaImediata: false,
                    formaPagamento: {},
                    itens: [],
                    taxaEntrega: null,
                    tokenCartaoCredito: null,
                    troco: null,
                    valorDesconto: null,
                    valorEntrega: null,
                    valorTotal: 0,
                    token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                }

                var attCardapio = retorno
                if (estabelecimentoAtual.adicionarItensNaTelaInicial) {
                    //preciso do "categorias" pq o retorno vem apenas as cateogrias
                    //adiciona o quantidade 0 para adicioanr no carrinho direto pelo cardapio
                    attCardapio = adicionarQuantidadeZeroProdutos({ categorias: retorno })
                }

                const dataRetorno = {}
                dataRetorno.categorias = attCardapio
                dataRetorno.id = "usuarioDeslogado"

                if (!usuarioLogado) {
                    setUsuarioLogado({})
                }

                if (!enderecoAtual) {
                    setEnderecoAtual({})
                }

                setCarrinho(carrinhoRetorno)

                setCardapio(dataRetorno)
            }
        } catch (error) {
            RegistrarLogErro(error, "resetarCarrinho")
            alertStart(
                "Procure os desenvolvedores! Erro resetarCarrinho: " + error.message,
                "error"
            )
        }
    }

    const adicionarEndereco = async (usuarioLogado, enderecoAtual) => {
        try {
            var resp = enderecoAtual

            const enderecoBackUp = JSON.parse(JSON.stringify(enderecoAtual))
            const data = {
                idCliente: usuarioLogado.cliente.id,
                idEstabelecimento: estabelecimentoAtual?.id ? estabelecimentoAtual?.id : null,
                cep: enderecoBackUp.cep,
                uf: enderecoBackUp.uf,
                cidade: enderecoBackUp.cidade,
                bairro: enderecoBackUp.bairro,
                logradouro: enderecoBackUp.logradouro,
                numero: enderecoBackUp.numero,
                complemento: enderecoBackUp.complemento,
                referencia: enderecoBackUp.referencia,
                token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
            }

            if (enderecoBackUp.bairroEspecifico) {
                data.bairroEspecifico = 1
            } else {
                data.bairroEspecifico = 0
            }

            const response = await CadastrarEnderecoCliente(data, aplicativoDados)

            if (response.retornoErro) {
                //algum erro
                alertStart(response.mensagem, "error")
                setLoading(false)
            } else {
                //tudo certo
                usuarioLogado.cliente.enderecos.push(response)
                if (!continuarSemCadastro && usuarioLogado?.logado) {
                    //para não logar ao selecionar endereço
                    setUsuarioLogado(usuarioLogado)
                }
                setEnderecoAtual(response)
                resp = response
            }
        } catch (error) {
            RegistrarLogErro(error, "CadastrarEnderecoCliente", { usuarioLogado, enderecoAtual })
            alertStart(
                "Procure os desenvolvedores! Erro CadastrarEnderecoCliente: " + error.message,
                "error"
            )
            setLoading(false)
        }
        return resp
    }

    async function enviarPedido({
        usuarioEnviarPedido = usuarioLogado,
        carrinhoEnviarPedido = carrinho,
    }) {
        try {
            const carrinho = carrinhoEnviarPedido
            let endereco = enderecoAtual

            const ddiInput = document.getElementById("ddi-select")
            const ddiCliente = ddiInput?.dataset.codigoPais
            carrinho.pedido.codigoPais = ddiCliente

            const isFreteGratisMinimoEntrega =
                carrinho?.pedido?.itens?.length > 0 &&
                carrinho?.minimoEntregaGratis < 999 &&
                carrinho?.minimoEntregaGratis > 0 &&
                itensValor - carrinho.valorDesconto - carrinho.percentualDescontoValor >=
                    carrinho?.minimoEntregaGratis
            const isRetiradaNoLocal =
                enderecoAtual?.id === "retirada" ||
                enderecoAtual?.id === -1 ||
                enderecoAtual?.logradouro === "Buscar no local"

            if (isUsuarioIzzaBot && !carrinho.pedido.nomePedido) {
                DialogConfirmacaoinformacoes(true)
                return true
            }

            setLoading(true)

            if (isEntregaNoEndereco && !enderecoAtual.id) {
                //if (!continuarSemCadastro) {

                //cadastrar endereço no usuario
                const retornoEndereco = await adicionarEndereco(usuarioEnviarPedido, enderecoAtual)
                retornoEndereco.taxaEntrega = enderecoAtual.taxaEntrega
                carrinho.pedido.taxaEntrega = enderecoAtual.taxaEntrega
                if (!retornoEndereco.id) {
                    alertStart("Aconteceu um erro no seu endereço. Tente novamente!", "error")
                    return false
                }
                setEnderecoAtual(retornoEndereco)
                endereco = retornoEndereco
                //}
            }

            const valorTotalPixelFacebook = carrinho.pedido.valorTotal

            //PREENCHIMENTO
            carrinho.pedido.estabelecimento = estabelecimentoAtual
            carrinho.pedido.cliente = usuarioEnviarPedido.cliente
            carrinho.pedido.end = endereco
            carrinho.pedido.tipoPedido = 0
            carrinho.pedido.plataforma = `react_js_site_V${Package.version}`
            carrinho.pedido.appNome = aplicativoDados.appNome
            carrinho.pedido.idCartelaCompleta = cardapio.idCartelaCompleta
            carrinho.pedido.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`
            const pedido = carrinho.pedido

            if (
                usuarioEnviarPedido?.logado &&
                usuarioEnviarPedido?.cliente?.enderecos?.length > 0
            ) {
                usuarioEnviarPedido.cliente.enderecos.forEach(endereco => {
                    if (aplicativoDados.tipoEntregaBairro == 1) {
                        endereco.bairroEspecifico = 1
                    } else {
                        endereco.bairroEspecifico = 0
                    }
                })
            } else if (
                usuarioEnviarPedido?.logado &&
                typeof usuarioEnviarPedido?.cliente?.enderecos == "string"
            ) {
                usuarioEnviarPedido.cliente.enderecos = null
            }

            if (aplicativoDados.tipoEntregaBairro == 1 && carrinho.pedido?.end) {
                carrinho.pedido.end.bairroEspecifico = 1
            } else {
                carrinho.pedido.end.bairroEspecifico = 0
            }

            //COMPLETA A RETIRIDA NO LOCAL
            if (isRetiradaNoLocal) {
                const vaiComerNoLocal =
                    aplicativoDados.permiteConsumoNoLocal &&
                    document.getElementById("comer-no-local-checkbox")?.checked

                if (vaiComerNoLocal) {
                    pedido.tipoPedido = 2
                    pedido.end.logradouro = "Consumir no local"
                    pedido.end.id = -2
                    pedido.entregaAgendada = "Consumir no local"
                } else {
                    pedido.tipoPedido = 1
                    pedido.end.logradouro = "Retirar no local"
                    pedido.end.id = -1
                }

                pedido.end.taxaEntrega = 0.0
                pedido.valorEntrega = 0.0
                pedido.taxaEntrega = 0.0
            }

            if (cardapio.cupomDesconto) {
                pedido.desconto = cardapio.cupomDesconto
            }

            if (carrinho.percentualDesconto) {
                pedido.valorDesconto = carrinho.percentualDescontoValor
            } else if (carrinho.valorDesconto) {
                pedido.valorDesconto = carrinho.valorDesconto
            }

            //DE ONDE FOI O PEDIDO
            if (isUsuarioPedidoMesa) {
                pedido.end = null
                pedido.tipoPedido = 2
            } else if (isUsuarioIzzaBot) {
                pedido.plataforma = `react_js_izzabot_V${Package.version}`
            }

            if (pedido.valorDesconto == null) {
                pedido.valorDesconto = 0
            }

            if (isFreteGratisMinimoEntrega || (!pedido.valorEntrega && !pedido.taxaEntrega)) {
                pedido.valorEntrega = 0
                pedido.taxaEntrega = 0
            }

            pedido.itens.forEach(item => {
                if (item.produto?.itensOpcaoProduto?.length) {
                    item.produto.itensOpcaoProduto.forEach(opcao => {
                        if (opcao?.opcaoProduto) {
                            console.log("opcao?.opcaoProduto", opcao.opcaoProduto.nome)
                            delete opcao.opcaoProduto.quantidade
                        }
                    })
                }
                console.log("item.produto", item.produto.nome)
                delete item.produto.quantidade
            })

            for (let index = 0; index < pedido?.itens?.length; index++) {
                if (pedido?.itens[index]?.produto?.itensOpcaoProduto?.length) {
                    for (let i = 0; i < pedido.itens[index].produto.itensOpcaoProduto.length; i++) {
                        delete pedido?.itens[index]?.produto?.itensOpcaoProduto[i]?.opcaoProduto
                            ?.quantidade
                    }
                }
                delete pedido?.itens[index]?.produto?.quantidade
                delete pedido?.itens[index]?.idEstabelecimento
            }

            //remover desconto percentual caso so tenha produto promocionais
            const pedidoCupomPercentual = !!(
                pedido.desconto && pedido.desconto.valorDescontoPercentual > 0
            )
            const pedidoFidelidadePercentual = !!(
                cardapio.percentualDesconto && cardapio.idCartelaCompleta
            )

            if (pedidoCupomPercentual || pedidoFidelidadePercentual) {
                console.log("if")
                let quantidadeProdutosPromocionais = 0
                pedido.itens.forEach(item => {
                    console.log("item", item)
                    if (item.produto.promocional) {
                        quantidadeProdutosPromocionais += 1
                    }
                })

                const todosPromocionais = pedido.itens.length === quantidadeProdutosPromocionais

                if (pedidoCupomPercentual && todosPromocionais) {
                    console.log("entrei")
                    pedido.desconto = null
                    pedido.valorDesconto = 0
                } else if (pedidoFidelidadePercentual && todosPromocionais) {
                    pedido.valorDesconto = 0
                    pedido.idCartelaCompleta = null
                }
            }

            if (!pedido.desconto) {
                pedido.desconto = null
            }

            if (
                isUsuarioPedidoMesa &&
                (!aplicativoDados.permiteEscolherPagamentoMesa || !carrinho.pedido.formaPagamento)
            ) {
                pedido.formaPagamento = {
                    id: 41,
                }
            }

            if (pedido.troco < pedido.valorTotal || pedido?.formaPagamento?.id !== 1) {
                pedido.troco = 0
            }

            //VERIFICA SE TA ABERTO A LOJA
            const retornoAberto = await EstabelecimentoAberto(
                estabelecimentoAtual.id,
                aplicativoDados
            )
            if (retornoAberto.retornoErro) {
                //algum erro EstabelecimentoAberto
                alertStart(retornoAberto.mensagem, "error")
                setLoading(false)
                // if((retornoAberto.mensagem).includes("valor mínimo")){
                DialogConfirmacaoinformacoes(false)

                // }
            } else {
                //tudo certoEstabelecimentoAberto

                estabelecimentoAtual.online = retornoAberto.online
                setEstabelecimentoAtual(estabelecimentoAtual)

                const estabelecimentoOffline = !retornoAberto.online && !usuarioPedidoMesa?.logado

                if (estabelecimentoOffline) {
                    alertStart("Esse estabelecimento está fechado no momento!", "warning")
                    setLoading(false)
                    return true
                } else if (!estabelecimentoOffline) {
                    if (retornoAberto.pausado) {
                        alertStart("Esse estabelecimento está pausado no momento!", "warning")
                        setLoading(false)
                        return true
                    }

                    console.log("pedido>>", pedido)
                    if (pedido.formaPagamento === null) {
                        alertStart("Selecione a forma de pagamento", "error")
                        DialogConfirmacaoinformacoes(false)
                        setLoading(false)
                        return
                    }
                    delete pedido.id
                    delete pedido.status

                    const cpfFinal = cpf ?? usuarioLogado?.cliente?.cpf

                    pedido.cliente.cpf = cpfFinal
                    pedido.cpfTitular = cpfFinal

                    // GetNet
                    if (pedido.formaPagamento?.id === 91) {
                        pedido.nomePedido = pedido.nomePedido
                            .split(" ")
                            .filter(n => n.replaceAll(/\s/g, "").length)
                            .join(" ")

                        if (!pedido.nomePedido.includes(" ")) {
                            alertStart(
                                'Para utilizar a forma de pagamento "Cartão (Online)" é necessário escrever nome e sobrenome',
                                "error"
                            )
                            setLoading(false)
                            return
                        }

                        const email = document
                            .getElementById("campo-display-email")
                            ?.innerText.split(" ")[1]

                        if (email && cpfFinal) {
                            localStorage.setItem("getnet-email", email)
                            pedido.cliente.email = email
                        } else {
                            alertStart(
                                'Para utilizar a forma de pagamento "Cartão (Online)" é necessário cadastrar seu e-mail e CPF',
                                "error"
                            )
                            setLoading(false)
                            return
                        }
                    }

                    const retornoPedido = await CadastrarPedido(pedido, aplicativoDados)

                    if (pedido.mesa && estabelecimentoAtual.possuiPedidoMesa === false) {
                        RegistrarLogErro({}, "erroMesaEntrega", { pedido, estabelecimentoAtual })
                    }

                    if (retornoPedido.tipoPedido === 1 && retornoPedido.taxaEntrega > 0) {
                        RegistrarLogErro({}, "erroTaxaRetirada", pedido)
                    }

                    if (retornoPedido.retornoErro) {
                        //algum erro CadastrarPedido

                        if (retornoPedido.retornoErro === 15) {
                            // alert(retornoPedido.retornoErro)
                            carrinho.pedido.cartaoCreditoCliente = null
                            carrinho.pedido.tokenCartaoCredito = null
                            carrinho.pedido.formaPagamento = null
                            carrinho.tokenCartaoCredito = null
                            carrinho.cartaoCreditoCliente = null
                            pedido.cartaoCreditoCliente = null
                            pedido.tokenCartaoCredito = null
                            pedido.formaPagamento = null
                            setCarrinho(carrinho)
                            DialogConfirmacaoinformacoes(false)
                            alertStart(retornoPedido.mensagem, "error")
                            setLoading(false)
                        }

                        if (
                            retornoPedido.retornoErro === 1 &&
                            retornoPedido.mensagem ===
                                "É preciso efetuar o login para prosseguir com seu pedido"
                        ) {
                            setLoading(false)
                            setAbrirDialogLogin(true)
                            alertStart(
                                "Por favor, autentique o seu telefone para finalizar o pedido",
                                "error"
                            )
                            return
                        }

                        alertStart(retornoPedido.mensagem, "error")
                        setLoading(false)
                    } else {
                        //tudo certo CadastrarPedido
                        //confirmar pedido
                        let retornoPedidoCorreto = retornoPedido
                        if (retornoPedido.status !== 0) {
                            const data = {
                                id: retornoPedido.id,
                                token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                                status: 0,
                            }
                            retornoPedidoCorreto = await AtualizarStatusPedido(
                                data,
                                aplicativoDados
                            )
                        }
                        if (retornoPedidoCorreto.retornoErro) {
                            if (
                                retornoPedido.formaPagamento.id === 91 &&
                                retornoPedido.status === 99
                            ) {
                                // TODO: Retirar
                                localStorage.setItem(
                                    "ultimoPedidoCF",
                                    JSON.stringify(retornoPedido)
                                )
                                history.push(
                                    `delivery/pedido/pablodelivery/${retornoPedido.id}/77?pedidoEnviado=true`
                                )
                                setLoading(false)
                                return
                            }
                            //algum erro AtualizarStatusPedido
                            alertStart(retornoPedidoCorreto.mensagem, "error")
                            setLoading(false)
                        } else {
                            //tudo certo AtualizarStatusPedido

                            //backup para caso o pedido seja cancelado
                            const pedidoCancelado = {
                                carrinho: carrinho,
                                usuario: usuarioLogado,
                            }
                            localStorage.setItem(
                                "PedidoCanceladoBackupCF",
                                JSON.stringify(pedidoCancelado)
                            )
                            localStorage.setItem("ultimoPedidoCF", JSON.stringify(retornoPedido))
                            window.dispatchEvent(new CustomEvent("enviarPedido"))
                            if (isUsuarioPedidoMesa) {
                                if (retornoPedidoCorreto.formaPagamento?.id === 88) {
                                    //PIX (Online)
                                    irParaStatusPedido(
                                        retornoPedidoCorreto.id,
                                        retornoPedidoCorreto.status,
                                        true
                                    )
                                } else {
                                    buscarHistoricoPedido()
                                }
                                alertStart("Pedido Enviado!", "success")
                                //setLoading(false);
                            } else {
                                eventoPurchase(valorTotalPixelFacebook)

                                irParaStatusPedido(
                                    retornoPedidoCorreto.id,
                                    retornoPedidoCorreto.status,
                                    true
                                ) //true significa que eu estou vindo do enviarPedido

                                if (continuarSemCadastro && !usuarioEnviarPedido?.logado) {
                                    setUsuarioLogado(null)
                                }
                            }
                            setCardapio(null)
                            setCarrinho(novoCarrinho())
                        }
                    }
                }
            }
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "enviarPedido", {
                usuarioEnviarPedido,
                carrinhoEnviarPedido,
            })
            alertStart("Procure os desenvolvedores! Erro enviarPedido: " + error.message, "error")
            setLoading(false)
        }
    }

    const buscarStatus = idPedido => {
        /* 
      AGUARDANDO_ACEITACAO = 0;
      ACEITO = 1;
      CONFIRMACAO_VISUALIZADA = 2;
      EM_ENTREGA = 3;
      ENTREGUE = 4;
      PAGO = 5;
      PRONTO = 6;
      EM_PRODUCAO = 7;
      AGUARDANDO ATUALIZAR STATUS = 10;

      CANCELADO_PELO_DISTRIBUIDOR = -1;
      CANCELADO_PELO_CLIENTE = -2;
      NAO_ENTREGUE = -3;
      EXPIRADO = -4;
      CHARGEBACK = -10;
    */
        switch (idPedido) {
            case 0:
                return "Aguardando Aceitação"
            case 1:
            case 2:
                return "Aceito"
            case 3:
                return "Saiu P/ Entrega"
            case 4:
                return "Entregue"
            case 5:
                return "Pago"
            case 6:
                return "Pronto P/ Entrega"
            case 7:
                return "Em Produção"
            case 77:
                return "Aguardando Pagamento"
            case -1:
                return "Cancelado Pelo Estabelecimento"
            case -2:
                return "Cancelado Pelo Cliente"
            case -3:
                return "Não Entregue"
            case -4:
                return "Expirado"
            case -10:
                return "ChargeBack"

            default:
                return "Não Identificado"
        }
    }

    const buscarHistoricoPedido = async () => {
        const data = usuarioLogado.cliente
        try {
            setLoading(true)
            data.appNome = aplicativoDados.appNome
            data.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`

            const response = await BuscarPedidosCliente(data, aplicativoDados)

            if (response.retornoErro) {
                //algum erro
                alertStart(response.mensagem, "error")
            } else {
                //tudo certo
                localStorage.setItem("historicoPedidosCF", JSON.stringify(response))
                if (response.length > 0) {
                    irParaHistoricoDePedidos()
                } else {
                    alertStart("Você ainda não fez pedidos", "warning")
                    setLoading(false)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "BuscarPedidosCliente", data)
            alertStart(
                "Procure os desenvolvedores! Erro BuscarPedidosCliente: " + error.message,
                "error"
            )
        }
    }

    // if (document.getElementById("aviso-lgpd")) document.getElementById("aviso-lgpd").style.bottom = "120px"

    // inicio HTML (RETURN)
    return (
        <div className={(classes.root, "divCardapio")}>
            {/* 3 lugar buscam o cardapio
          - clicando pra selecionar endereço
          - clicando pra selecionar estabelecimento
          - clicando no menu delivery sem selecionar estabelecimento ( ele escolhe por padrao o estabelecimento da posição 0 )

        */}

            {/* Existe 2 tipos de cardapio ( GRID e LIST )
          cada um tem suas funções, então caso for mexer em algum é necessario mexer nos 2.
        */}

            <InfoCardapio
                isEntregaNoEndereco={isEntregaNoEndereco}
                isRetiradaNoLocal={isRetiradaNoLocal}
                taxa={valorTaxaEntrega}
                mostrarWhatsapp={mostrarWhatsapp}
                estabelecimentoAtual={estabelecimentoAtual}
                enderecoAtual={enderecoAtual}
                setRodarFuncaoAposIsso={setRodarFuncaoAposIsso}
                opcoesParaEntregaeRetirada={opcoesParaEntregaeRetirada}
                irParaEnderecos={irParaEnderecos}
                cardapio={cardapio}
                aplicativoDados={aplicativoDados}
                history={history}
                temEndereco={temEndereco}
                usuario={usuarioLogado}
                visualizacao={props.visualizacao}
                usuarioPedidoMesa={usuarioPedidoMesa}
                isUsuarioPedidoMesa={isUsuarioPedidoMesa}
            />

            {!ultimoPedido.id ? null : (
                <Row style={{ marginBottom: "1em", cursor: "pointer" }}>
                    <Col xs={12} md={12} lg={12}>
                        <AlertFixo
                            onClick={() => {
                                if (usuarioPedidoMesa?.logado) {
                                    buscarHistoricoPedido()
                                } else {
                                    irParaStatusPedido(ultimoPedido.id, ultimoPedido.status, false)
                                }
                            }}
                            className="campoDeUmAlert"
                            severity={ultimoPedido.status >= 0 ? "success" : "error"}
                        >
                            Pedido de <b>{formatarParaDinheiro(ultimoPedido.valorTotal)}</b>{" "}
                            <b>
                                {ultimoPedido.strDataRealizacao
                                    ? "realizado em " + ultimoPedido.strDataRealizacao
                                    : ""}
                            </b>{" "}
                            está com status <b>{buscarStatus(ultimoPedido.status)}</b>
                        </AlertFixo>
                    </Col>
                </Row>
            )}

            {!usuarioPedidoMesa?.logado &&
                ((carrinho.minimoEntregaGratis < 999 && carrinho.minimoEntregaGratis > 0) ||
                    (carrinho.valorMinimoPedido > 0 && !isRetiradaValorMinimo) ||
                    isRetiradaValorMinimo ||
                    cardapio.valorDesconto > 0 ||
                    cardapio.percentualDesconto > 0 ||
                    enderecoAtual.id) && (
                    <Dialog
                        open={openInformacoes} //true,openInformacoes
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setOpenInformacoes(false)
                        }}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        {/* <DialogTitle id="alert-dialog-slide-title">{"Informações Importantes"}</DialogTitle> */}
                        <img src={aplicativoDados.urlLogo} className="imgModal" />

                        <DialogTitle id="informarcoesImportantes">
                            <IconButton
                                className="setaVoltarModal"
                                onClick={() => {
                                    setOpenInformacoes(false)
                                }}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>
                            Informações Importantes
                        </DialogTitle>

                        <DialogContent>
                            <div className={classes.rootAlerts}>
                                {
                                    /* ========== ALERTA FRETE GRÁTIS ACIMA DE X REAIS ============ */
                                    carrinho.minimoEntregaGratis < 999 &&
                                        carrinho.minimoEntregaGratis > 0 && (
                                            <AlertFixo
                                                severity={
                                                    isFreteGratisMinimoEntrega
                                                        ? "success"
                                                        : "warning"
                                                }
                                                className="campoDeUmAlert"
                                            >
                                                Frete Grátis acima de{" "}
                                                <b>
                                                    {formatarParaDinheiro(
                                                        carrinho.minimoEntregaGratis
                                                    )}
                                                </b>{" "}
                                                no total dos produtos.
                                            </AlertFixo>
                                        )
                                }

                                {
                                    /* ========== ALERTA MINIMO PARA REALIZAR PEDIDO ============ */
                                    isRetiradaValorMinimo ? (
                                        <AlertFixo
                                            severity={
                                                valorTotalMinimoEntregaPedido >
                                                carrinho.valorMinimoRetiradaNoLocal
                                                    ? "success"
                                                    : "warning"
                                            }
                                            className="campoDeUmAlert"
                                        >
                                            O valor minimo do pedido para retirada é de{" "}
                                            <b>
                                                {formatarParaDinheiro(
                                                    carrinho.valorMinimoRetiradaNoLocal
                                                )}{" "}
                                            </b>
                                        </AlertFixo>
                                    ) : carrinho.valorMinimoPedido > 0 && !isRetiradaValorMinimo ? (
                                        <AlertFixo
                                            severity={
                                                valorTotalMinimoEntregaPedido >
                                                carrinho.valorMinimoPedido
                                                    ? "success"
                                                    : "warning"
                                            }
                                            className="campoDeUmAlert"
                                        >
                                            O valor minimo do pedido é de{" "}
                                            <b>
                                                {formatarParaDinheiro(carrinho.valorMinimoPedido)}{" "}
                                            </b>
                                        </AlertFixo>
                                    ) : null
                                }

                                {
                                    /* ========== ALERTA DESCONTO PROXIMO PEDIDO ============ */
                                    (cardapio.valorDesconto > 0 ||
                                        cardapio.percentualDesconto > 0) && (
                                        <AlertFixo className="campoDeUmAlert" severity="success">
                                            {"Desconto no próximo pedido  "}
                                            <b>
                                                {cardapio.valorDesconto > 0
                                                    ? formatarParaDinheiro(cardapio.valorDesconto) +
                                                      " no valor dos produtos"
                                                    : cardapio.percentualDesconto +
                                                      "% no valor dos produtos"}
                                            </b>
                                        </AlertFixo>
                                    )
                                }

                                {/* {enderecoAtual.taxaEntrega === -1  */}
                                {isEntregaNoEndereco === false && temEndereco ? (
                                    /* ========== ALERTA ESTABELECIMENTO NAO ENTREGA NESSE ENDEREÇO ============ */
                                    <>
                                        <AlertFixo
                                            className="campoDeUmAlert"
                                            onClick={() => {
                                                if (estabelecimentoAtual.permiteRetiradaBalcao) {
                                                    setTelaRetiradaOuEntrega(true)
                                                } else {
                                                    irParaEnderecos()
                                                }
                                            }}
                                            severity="error"
                                        >
                                            {" "}
                                            Essa loja não entrega no seu endereço{" "}
                                            <b>
                                                {enderecoAtual.logradouro}, {enderecoAtual.numero} -{" "}
                                                {enderecoAtual.bairro}
                                            </b>{" "}
                                            <Button
                                                onClick={() => {
                                                    setTelaRetiradaOuEntrega(true)
                                                }}
                                                style={{ padding: "0px", fontSize: "80%" }}
                                            >
                                                Trocar
                                            </Button>
                                        </AlertFixo>

                                        {outrosEstabelecimentosEntregam.length ? (
                                            <AlertFixo
                                                className="campoDeUmAlert"
                                                onClick={() => {}}
                                                severity="error"
                                            >
                                                {" "}
                                                Existe outro estabelecimento que entregam nesse
                                                endereço.
                                                <Button
                                                    style={{ padding: "0px", fontSize: "80%" }}
                                                    onClick={() => {
                                                        history.push("/lojas")
                                                    }}
                                                >
                                                    trocar
                                                </Button>
                                            </AlertFixo>
                                        ) : null}
                                    </>
                                ) : /* ========== ALERTA ENDEREÇO SELECIONADO ============ */
                                enderecoAtual.logradouro && !isRetiradaNoLocal ? (
                                    <AlertFixo
                                        onClick={() => {
                                            if (estabelecimentoAtual.permiteRetiradaBalcao) {
                                                setTelaRetiradaOuEntrega(true)
                                            } else {
                                                irParaEnderecos()
                                            }
                                        }}
                                        severity="success"
                                    >
                                        {" "}
                                        Endereço selecionado é{" "}
                                        <b>
                                            {enderecoAtual.logradouro}, {enderecoAtual.numero} -{" "}
                                            {enderecoAtual.bairro}
                                        </b>{" "}
                                    </AlertFixo>
                                ) : null}

                                {
                                    /* ========== ALERTA RETIRADA NO LOCAL ============ */
                                    isRetiradaNoLocal && (
                                        <AlertFixo
                                            style={{ cursor: "pointer" }}
                                            className="campoDeUmAlert"
                                            severity="success"
                                            onClick={() => {
                                                if (estabelecimentoAtual?.permiteRetiradaBalcao) {
                                                    setTelaRetiradaOuEntrega(true)
                                                } else {
                                                    irParaEnderecos()
                                                }
                                            }}
                                        >
                                            Você selecionou Buscar no Local
                                        </AlertFixo>
                                    )
                                }
                            </div>
                        </DialogContent>
                        {/* <DialogActions>
              <Button onClick={() =>{setOpenInformacoes(false)}} style={{"color": "#dc3545"}}>
                voltar
              </Button>
            </DialogActions> */}
                    </Dialog>
                )}

            {cardapio.id &&
            cardapio.idEstabelecimento === estabelecimentoAtual.id &&
            cardapio.categorias?.length > 0 ? (
                <>
                    <Row>
                        <div
                            className={classes.rootCardapio}
                            id="divCatalago"
                            style={iphone || android ? { zIndex: "999" } : undefined}
                        >
                            <div className={classes.cabecalho}>
                                <CabecalhoCategorias />
                                <BuscaProdutos />
                            </div>

                            {/* // ====== GRID E LIST ====== */}

                            {cardapio.categorias.map(categoria =>
                                categoria.produtos.length > 0 ? (
                                    <CategoriaGrid
                                        key={categoria.id}
                                        categoria={categoria}
                                        layout={layoutCardapio}
                                        selecionarProduto={selecionarProduto}
                                        removerProdutoCarrinho={removerProdutoCarrinho}
                                        adicionarProdutoCarrinho={adicionarProdutoCarrinho}
                                        numberoProdutoCarrinho={numberoProdutoCarrinho}
                                    />
                                ) : null
                            )}
                        </div>
                    </Row>
                </>
            ) : (
                <CardapioPlaceHolder layout={layoutCardapio} categorias={cardapio.categorias} />
            )}

            {aplicativoDados?.exibirDesenvolvidoPor && (
                <Row>
                    <Col xs={12} md={12} lg={12} style={{ textAlign: "center" }}>
                        <a
                            target="new_blank"
                            href={"http://appclientefiel.com.br/?utm_source=siteDeAlgumCliente"}
                        >
                            <img
                                className="desenvolvidopor"
                                alt="desenvolvido por app cliente fiel"
                                src={DesenvolvidoPor}
                            />
                            <span style={{ color: aplicativoDados.corSitePrimaria }}>
                                Site Cliente Fiel
                            </span>
                        </a>
                    </Col>
                </Row>
            )}

            <Carrinho
                // calcularValorProdutos={calcularValorProdutos}
                valorProdutos={valorProdutos}
                openTelaLogin={openTelaLogin}
                valorTotalMinimoEntregaPedido={valorTotalMinimoEntregaPedido}
                valorTotalMinimoEntregaCupom={valorTotalMinimoEntregaCupom}
                setOpenTelaLogin={setOpenTelaLogin}
                queroMeCadastrar={queroMeCadastrar}
                setQueroMeCadastrar={setQueroMeCadastrar}
                visualizacao={props.visualizacao}
                carrinho={carrinho}
                history={history}
                removerProdutoCarrinho={removerProdutoCarrinho}
                numberoProdutoCarrinho={numberoProdutoCarrinho}
                adicionarProdutoCarrinho={adicionarProdutoCarrinho}
                loading={loading}
                solicitarTelefoneAoFinalizar={solicitarTelefoneAoFinalizar}
                solicitarNomeAoFinalizar={solicitarNomeAoFinalizar}
                iphone={iphone}
                outrosEstabelecimentosEntregam={outrosEstabelecimentosEntregam}
                valorTaxaEntrega={valorTaxaEntrega}
                android={android}
                classes={classes}
                setCarrinhoOpen={setCarrinhoOpen}
                estabelecimentoAtual={estabelecimentoAtual}
                aplicativoDados={aplicativoDados}
                quantidadeProdutos={quantidadeProdutos}
                removeItem={removeItem}
                setRemoveItem={setRemoveItem}
                removeItemSelecionado={removeItemSelecionado}
                setCarrinho={setCarrinho}
                setAdicionarCupom={setAdicionarCupom}
                adicionarCupom={adicionarCupom}
                fullScreen={fullScreen}
                carrinhoOpen={carrinhoOpen}
                isEntregaNoEndereco={isEntregaNoEndereco}
                usuarioPedidoMesa={usuarioPedidoMesa}
                setInformacoesDoTipoEntrega={setInformacoesDoTipoEntrega}
                isRetiradaNoLocal={isRetiradaNoLocal}
                isUsuarioPedidoMesa={isUsuarioPedidoMesa}
                temEndereco={temEndereco}
                setEnderecoAtual={setEnderecoAtual}
                enderecoAtual={enderecoAtual}
                setTelaRetiradaOuEntrega={setTelaRetiradaOuEntrega}
                usuarioLogado={usuarioLogado}
                // setContinuarSemCadastro={setContinuarSemCadastro}
                continuarSemCadastro={continuarSemCadastro}
                isFreteGratisMinimoEntrega={isFreteGratisMinimoEntrega}
                DialogConfirmacaoinformacoes={DialogConfirmacaoinformacoes}
                alertStart={alertStart}
                setRodarFuncaoAposIsso={setRodarFuncaoAposIsso}
                setInformacoesPedido={setInformacoesPedido}
                irParaEnderecos={irParaEnderecos}
                qrCodeModal={qrCodeModal}
                setQrCodeModal={setQrCodeModal}
                informacoesPedido={informacoesPedido}
                isNumeric={isNumeric}
                nomeMesa={nomeMesa}
                numeroMesas={numeroMesas}
                confirmacaoInformacoes={confirmacaoInformacoes}
                setLoading={setLoading}
                formatReal={formatReal}
                getMoney={getMoney}
                setAbrirMostrarFotoProduto={setAbrirMostrarFotoProduto}
                irParaProduto={irParaProduto}
                selecioneiRetiradaNoLocal={selecioneiRetiradaNoLocal}
                selecioneiEndereco={selecioneiEndereco}
                cardapio={cardapio}
                descontoCardapio={descontoCardapio}
                removerCupom={removerCupom}
                setRemoveItemSelecionado={setRemoveItemSelecionado}
                irParaLogin={irParaLogin}
                AdicionarCupom={AdicionarCupom}
                AvatarTipoEntrega={AvatarTipoEntrega}
                EnderecoPedidoMesa={EnderecoPedidoMesa}
                QRCode={QRCode}
                InformacoesDoTipoEntrega={InformacoesDoTipoEntrega}
                AbrirMostrarFotoProduto={AbrirMostrarFotoProduto}
                MostrarFotoProduto={MostrarFotoProduto}
                TelaRetiradaOuEntrega={TelaRetiradaOuEntrega}
                cpf={cpf}
                setCpf={setCpf}
            />
        </div>
    )
}
